export default __webpack_public_path__ + "static/media/step3-v2.ce1c5e57.png";